// extracted by mini-css-extract-plugin
export default {"title":"StepLayout_title__BoKGh","buttons":"StepLayout_buttons__B79Gr"};